/**
 * Studio UI for reseller sharing (sharing mode, reseller customers, reseller links, the reseller tree).
 * Buyer pages follow the server instead: they only change when public-status says `resellerSharing`.
 */
export const isCatalogueResellerSharingEnabled = (): boolean =>
  process.env.REACT_APP_CATALOGUE_RESELLER_SHARING === "true";
